import { FC, ReactNode, useEffect } from "react";

type Callback = (() => void) | undefined;

interface CallbackProps {
    callback?: Callback;
    children: ReactNode;
}

interface CallbackComponentProps {
    callback?: Callback;
}

const CallbackComponent: FC<CallbackComponentProps> = ({ callback }) => {
    useEffect(() => {
        callback?.();
    }, [callback]);

    return null;
};

const RenderCallback: FC<CallbackProps> = ({ callback, children }) => {
    return (
        <>
            {children}
            <CallbackComponent callback={callback} />
        </>
    );
};

export default RenderCallback;
